/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetPageDocument = gql`
    query GetPage($id: Int!) {
  page(id: $id) {
    id
    title
    type
    image
    contentString
    prePublishContentString
    purposeType
    seoTitle
    seoKeywords
    seoDescription
    noIndex
    script
    canPublish
    published
    pageWatermark
    parentPage {
      id
      title
      publicUrl
      subPages {
        id
        title
        publicUrl
        childPage
        parentPage {
          id
        }
      }
    }
    parentTemplate {
      id
      templates {
        id
        type
        content
        img
      }
    }
    subPages {
      id
      title
      publicUrl
      childPage
      published
      parentPage {
        id
      }
    }
    user {
      userName
      roles
      email
    }
    pageSocial {
      id
      link
      name
      typeName
    }
    userAccesses {
      accessType
      user {
        email
        roles
        userName
      }
    }
    publicUrl
    folder {
      id
    }
    domain {
      id
    }
    accessPageFolderDomainByPriority
    preloaderFile {
      fileName
      id
      size
      fullFilePath
      extension
    }
    rootPage
    childPage
    pageAgeRestriction {
      checkboxAge18
    }
    pageForms {
      id
      uniqueKey
      type
      typeLabel
      isSendEmail
      email
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetPageQuery__
 *
 * To run a query within a React component, call `useGetPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPageQuery(baseOptions: Apollo.QueryHookOptions<GetPageQuery, GetPageQueryVariables> & ({ variables: GetPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageQuery, GetPageQueryVariables>(GetPageDocument, options);
      }
export function useGetPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageQuery, GetPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageQuery, GetPageQueryVariables>(GetPageDocument, options);
        }
export function useGetPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageQuery, GetPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageQuery, GetPageQueryVariables>(GetPageDocument, options);
        }
export type GetPageQueryHookResult = ReturnType<typeof useGetPageQuery>;
export type GetPageLazyQueryHookResult = ReturnType<typeof useGetPageLazyQuery>;
export type GetPageSuspenseQueryHookResult = ReturnType<typeof useGetPageSuspenseQuery>;
export type GetPageQueryResult = Apollo.QueryResult<GetPageQuery, GetPageQueryVariables>;
export const UpdatePageDataDocument = gql`
    mutation UpdatePageData($id: Int!, $title: String, $seoTitle: String, $watermark: Boolean) {
  updatePage(id: $id, title: $title, seoTitle: $seoTitle, watermark: $watermark) {
    title
  }
}
    `;
export type UpdatePageDataMutationFn = Apollo.MutationFunction<UpdatePageDataMutation, UpdatePageDataMutationVariables>;

/**
 * __useUpdatePageDataMutation__
 *
 * To run a mutation, you first call `useUpdatePageDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageDataMutation, { data, loading, error }] = useUpdatePageDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      seoTitle: // value for 'seoTitle'
 *      watermark: // value for 'watermark'
 *   },
 * });
 */
export function useUpdatePageDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageDataMutation, UpdatePageDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageDataMutation, UpdatePageDataMutationVariables>(UpdatePageDataDocument, options);
      }
export type UpdatePageDataMutationHookResult = ReturnType<typeof useUpdatePageDataMutation>;
export type UpdatePageDataMutationResult = Apollo.MutationResult<UpdatePageDataMutation>;
export type UpdatePageDataMutationOptions = Apollo.BaseMutationOptions<UpdatePageDataMutation, UpdatePageDataMutationVariables>;
export const PageCategoryDocument = gql`
    query PageCategory {
  pageCategory {
    id
    title
    pagesSortedByPosition {
      id
      type
      title
      image
    }
  }
}
    `;

/**
 * __usePageCategoryQuery__
 *
 * To run a query within a React component, call `usePageCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageCategoryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePageCategoryQuery(baseOptions?: Apollo.QueryHookOptions<PageCategoryQuery, PageCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageCategoryQuery, PageCategoryQueryVariables>(PageCategoryDocument, options);
      }
export function usePageCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageCategoryQuery, PageCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageCategoryQuery, PageCategoryQueryVariables>(PageCategoryDocument, options);
        }
export function usePageCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageCategoryQuery, PageCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageCategoryQuery, PageCategoryQueryVariables>(PageCategoryDocument, options);
        }
export type PageCategoryQueryHookResult = ReturnType<typeof usePageCategoryQuery>;
export type PageCategoryLazyQueryHookResult = ReturnType<typeof usePageCategoryLazyQuery>;
export type PageCategorySuspenseQueryHookResult = ReturnType<typeof usePageCategorySuspenseQuery>;
export type PageCategoryQueryResult = Apollo.QueryResult<PageCategoryQuery, PageCategoryQueryVariables>;
export const EditPageContentDocument = gql`
    mutation EditPageContent($pageId: Int!, $content: String!, $prePublishContent: String!) {
  editPageContent(
    pageId: $pageId
    content: $content
    prePublishContent: $prePublishContent
  ) {
    id
  }
}
    `;
export type EditPageContentMutationFn = Apollo.MutationFunction<EditPageContentMutation, EditPageContentMutationVariables>;

/**
 * __useEditPageContentMutation__
 *
 * To run a mutation, you first call `useEditPageContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPageContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPageContentMutation, { data, loading, error }] = useEditPageContentMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      content: // value for 'content'
 *      prePublishContent: // value for 'prePublishContent'
 *   },
 * });
 */
export function useEditPageContentMutation(baseOptions?: Apollo.MutationHookOptions<EditPageContentMutation, EditPageContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPageContentMutation, EditPageContentMutationVariables>(EditPageContentDocument, options);
      }
export type EditPageContentMutationHookResult = ReturnType<typeof useEditPageContentMutation>;
export type EditPageContentMutationResult = Apollo.MutationResult<EditPageContentMutation>;
export type EditPageContentMutationOptions = Apollo.BaseMutationOptions<EditPageContentMutation, EditPageContentMutationVariables>;
export const SavePageFormSettingsDocument = gql`
    mutation SavePageFormSettings($pageId: Int!, $uniqueKey: String!, $type: String!, $isSendEmail: Boolean!, $id: Int, $email: String) {
  savePageFormSettings(
    pageId: $pageId
    uniqueKey: $uniqueKey
    type: $type
    isSendEmail: $isSendEmail
    id: $id
    email: $email
  ) {
    id
    pageId
    uniqueKey
    type
    typeLabel
    isSendEmail
    email
    createdAt
    updatedAt
  }
}
    `;
export type SavePageFormSettingsMutationFn = Apollo.MutationFunction<SavePageFormSettingsMutation, SavePageFormSettingsMutationVariables>;

/**
 * __useSavePageFormSettingsMutation__
 *
 * To run a mutation, you first call `useSavePageFormSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePageFormSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePageFormSettingsMutation, { data, loading, error }] = useSavePageFormSettingsMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      uniqueKey: // value for 'uniqueKey'
 *      type: // value for 'type'
 *      isSendEmail: // value for 'isSendEmail'
 *      id: // value for 'id'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSavePageFormSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SavePageFormSettingsMutation, SavePageFormSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePageFormSettingsMutation, SavePageFormSettingsMutationVariables>(SavePageFormSettingsDocument, options);
      }
export type SavePageFormSettingsMutationHookResult = ReturnType<typeof useSavePageFormSettingsMutation>;
export type SavePageFormSettingsMutationResult = Apollo.MutationResult<SavePageFormSettingsMutation>;
export type SavePageFormSettingsMutationOptions = Apollo.BaseMutationOptions<SavePageFormSettingsMutation, SavePageFormSettingsMutationVariables>;
export const DeletePageSocialLinksDocument = gql`
    mutation DeletePageSocialLinks($pageId: Int!) {
  deletePageSocialLinks(pageId: $pageId) {
    id
  }
}
    `;
export type DeletePageSocialLinksMutationFn = Apollo.MutationFunction<DeletePageSocialLinksMutation, DeletePageSocialLinksMutationVariables>;

/**
 * __useDeletePageSocialLinksMutation__
 *
 * To run a mutation, you first call `useDeletePageSocialLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePageSocialLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePageSocialLinksMutation, { data, loading, error }] = useDeletePageSocialLinksMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useDeletePageSocialLinksMutation(baseOptions?: Apollo.MutationHookOptions<DeletePageSocialLinksMutation, DeletePageSocialLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePageSocialLinksMutation, DeletePageSocialLinksMutationVariables>(DeletePageSocialLinksDocument, options);
      }
export type DeletePageSocialLinksMutationHookResult = ReturnType<typeof useDeletePageSocialLinksMutation>;
export type DeletePageSocialLinksMutationResult = Apollo.MutationResult<DeletePageSocialLinksMutation>;
export type DeletePageSocialLinksMutationOptions = Apollo.BaseMutationOptions<DeletePageSocialLinksMutation, DeletePageSocialLinksMutationVariables>;
export const PageNewDocument = gql`
    mutation PageNew($title: String!, $url: String!, $seoTitle: String, $seoKeyWords: String, $seoDescription: String, $image: String, $folderId: Int, $domainId: Int, $type: Int, $noIndex: Boolean, $pageScript: String, $parentPageId: Int, $copyParentPageContent: Boolean) {
  pageNew(
    title: $title
    url: $url
    seoTitle: $seoTitle
    seoKeyWords: $seoKeyWords
    seoDescription: $seoDescription
    image: $image
    folderId: $folderId
    domainId: $domainId
    type: $type
    noIndex: $noIndex
    pageScript: $pageScript
    parentPageId: $parentPageId
    copyParentPageContent: $copyParentPageContent
  ) {
    id
    title
  }
}
    `;
export type PageNewMutationFn = Apollo.MutationFunction<PageNewMutation, PageNewMutationVariables>;

/**
 * __usePageNewMutation__
 *
 * To run a mutation, you first call `usePageNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePageNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pageNewMutation, { data, loading, error }] = usePageNewMutation({
 *   variables: {
 *      title: // value for 'title'
 *      url: // value for 'url'
 *      seoTitle: // value for 'seoTitle'
 *      seoKeyWords: // value for 'seoKeyWords'
 *      seoDescription: // value for 'seoDescription'
 *      image: // value for 'image'
 *      folderId: // value for 'folderId'
 *      domainId: // value for 'domainId'
 *      type: // value for 'type'
 *      noIndex: // value for 'noIndex'
 *      pageScript: // value for 'pageScript'
 *      parentPageId: // value for 'parentPageId'
 *      copyParentPageContent: // value for 'copyParentPageContent'
 *   },
 * });
 */
export function usePageNewMutation(baseOptions?: Apollo.MutationHookOptions<PageNewMutation, PageNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PageNewMutation, PageNewMutationVariables>(PageNewDocument, options);
      }
export type PageNewMutationHookResult = ReturnType<typeof usePageNewMutation>;
export type PageNewMutationResult = Apollo.MutationResult<PageNewMutation>;
export type PageNewMutationOptions = Apollo.BaseMutationOptions<PageNewMutation, PageNewMutationVariables>;
export type GetPageQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type GetPageQuery = { __typename?: 'Query', page: { __typename?: 'GraphPage', id?: number | null, title?: string | null, type?: number | null, image?: string | null, contentString: string, prePublishContentString?: string | null, purposeType?: number | null, seoTitle?: string | null, seoKeywords?: string | null, seoDescription?: string | null, noIndex?: boolean | null, script?: string | null, canPublish: boolean, published: boolean, pageWatermark?: boolean | null, publicUrl?: string | null, accessPageFolderDomainByPriority: number, rootPage: boolean, childPage: boolean, parentPage?: { __typename?: 'GraphPage', id?: number | null, title?: string | null, publicUrl?: string | null, subPages: Array<{ __typename?: 'GraphPage', id?: number | null, title?: string | null, publicUrl?: string | null, childPage: boolean, parentPage?: { __typename?: 'GraphPage', id?: number | null } | null }> } | null, parentTemplate?: { __typename?: 'GraphPage', id?: number | null, templates: Array<{ __typename?: 'GraphTemplate', id?: number | null, type?: number | null, content?: string | null, img?: string | null }> } | null, subPages: Array<{ __typename?: 'GraphPage', id?: number | null, title?: string | null, publicUrl?: string | null, childPage: boolean, published: boolean, parentPage?: { __typename?: 'GraphPage', id?: number | null } | null }>, user: { __typename?: 'User', userName: string, roles: Array<string>, email?: string | null }, pageSocial: Array<{ __typename?: 'GraphPageSocial', id?: number | null, link?: string | null, name?: string | null, typeName?: string | null }>, userAccesses: Array<{ __typename?: 'UserAccess', accessType?: number | null, user?: { __typename?: 'User', email?: string | null, roles: Array<string>, userName: string } | null }>, folder?: { __typename?: 'GraphFolder', id: number } | null, domain: { __typename?: 'GraphDomain', id?: number | null }, preloaderFile?: { __typename?: 'GraphFile', fileName: string, id?: number | null, size?: number | null, fullFilePath: string, extension: string } | null, pageAgeRestriction?: { __typename?: 'GraphPageAgeRestriction', checkboxAge18: boolean } | null, pageForms: Array<{ __typename?: 'GraphPageForm', id?: number | null, uniqueKey?: string | null, type?: string | null, typeLabel?: string | null, isSendEmail: boolean, email?: string | null, createdAt?: any | null, updatedAt?: any | null }> } };

export type UpdatePageDataMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  title?: Types.InputMaybe<Types.Scalars['String']['input']>;
  seoTitle?: Types.InputMaybe<Types.Scalars['String']['input']>;
  watermark?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdatePageDataMutation = { __typename?: 'Mutation', updatePage: { __typename?: 'GraphPage', title?: string | null } };

export type PageCategoryQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PageCategoryQuery = { __typename?: 'Query', pageCategory?: Array<{ __typename?: 'GraphPageCategory', id?: number | null, title?: string | null, pagesSortedByPosition: Array<{ __typename?: 'GraphPage', id?: number | null, type?: number | null, title?: string | null, image?: string | null }> }> | null };

export type EditPageContentMutationVariables = Types.Exact<{
  pageId: Types.Scalars['Int']['input'];
  content: Types.Scalars['String']['input'];
  prePublishContent: Types.Scalars['String']['input'];
}>;


export type EditPageContentMutation = { __typename?: 'Mutation', editPageContent: { __typename?: 'GraphPage', id?: number | null } };

export type SavePageFormSettingsMutationVariables = Types.Exact<{
  pageId: Types.Scalars['Int']['input'];
  uniqueKey: Types.Scalars['String']['input'];
  type: Types.Scalars['String']['input'];
  isSendEmail: Types.Scalars['Boolean']['input'];
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  email?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SavePageFormSettingsMutation = { __typename?: 'Mutation', savePageFormSettings: { __typename?: 'GraphPageForm', id?: number | null, pageId?: number | null, uniqueKey?: string | null, type?: string | null, typeLabel?: string | null, isSendEmail: boolean, email?: string | null, createdAt?: any | null, updatedAt?: any | null } };

export type DeletePageSocialLinksMutationVariables = Types.Exact<{
  pageId: Types.Scalars['Int']['input'];
}>;


export type DeletePageSocialLinksMutation = { __typename?: 'Mutation', deletePageSocialLinks: { __typename?: 'GraphPage', id?: number | null } };

export type PageNewMutationVariables = Types.Exact<{
  title: Types.Scalars['String']['input'];
  url: Types.Scalars['String']['input'];
  seoTitle?: Types.InputMaybe<Types.Scalars['String']['input']>;
  seoKeyWords?: Types.InputMaybe<Types.Scalars['String']['input']>;
  seoDescription?: Types.InputMaybe<Types.Scalars['String']['input']>;
  image?: Types.InputMaybe<Types.Scalars['String']['input']>;
  folderId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  domainId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  type?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  noIndex?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  pageScript?: Types.InputMaybe<Types.Scalars['String']['input']>;
  parentPageId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  copyParentPageContent?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type PageNewMutation = { __typename?: 'Mutation', pageNew: { __typename?: 'GraphPage', id?: number | null, title?: string | null } };

